import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MaterialLink } from '@mui/material';

interface Props extends React.ButtonHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  className?: string;
  link: Link;
  target?: string;
}

/*

Use this component when we don’t know whether a link is going to be internal
(and handled by React Router’s Link via Material’s Link component) or
external (and handled by Material’s Link component on its own).

*/

const Anchor: React.FC<Props> = ({
  children, className, link, onClick, target,
}: Props) => {
  if (link.type === 'url') {
    return (
      <MaterialLink
        href={link.link}
        className={className}
        onClick={onClick || (() => {})}
        target={target || '_self'}
      >
        {children}
      </MaterialLink>
    );
  }

  return (
    <MaterialLink
      component={RouterLink}
      to={link.link}
      className={className}
      onClick={onClick || (() => { })}
      rel="noopener noreferrer"
      target={target || '_self'}
    >
      {children}
    </MaterialLink>
  );
};

export default Anchor;
